import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const AboutServices = createApi({
	reducerPath: "AboutServices",
	baseQuery: fetchBaseQuery({
		baseUrl: "https://flit-backend.developer-ourbase-camp.com/api/",
	}),
	endpoints: (builder) => {
		return {
			aboutContent: builder.query({
				query: () => {
					return {
						url: "pages/about-us",
						method: "GET",
					};
				},
			}),
		};
	},
});
export const { useAboutContentQuery } = AboutServices;
export default AboutServices;
